import { SlotAvailabilityType } from 'app/Bookings/constants'
import { availabilityColorMapping } from 'app/ProviderSearch/constants'
import styles from './index.module.scss'

type SlotAvailabilityIndicatorProps = {
  slotAvailabilities: SlotAvailabilityType[]
  className?: string
}

const SlotAvailabilityIndicator: React.FC<SlotAvailabilityIndicatorProps> = ({
  slotAvailabilities,
  className,
}) => (
  <div className={`${className} d-flex`}>
    {slotAvailabilities.sort().map((slotAvailability) => (
      <div
        key={slotAvailability}
        className={`${styles.indicator} rounded-circle`}
        style={{
          backgroundColor: availabilityColorMapping[slotAvailability],
        }}
      />
    ))}
  </div>
)

export default SlotAvailabilityIndicator
